var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.508,
    height: 27.508,
    viewBox: "0 0 27.508 27.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8402 12003.446)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8402 -12003.446)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.912,0H8.6A8.6,8.6,0,0,0,0,8.6V18.912a8.6,8.6,0,0,0,8.6,8.6H18.912a8.6,8.6,0,0,0,8.6-8.6V8.6A8.6,8.6,0,0,0,18.912,0Zm6.017,18.912a6.024,6.024,0,0,1-6.017,6.017H8.6a6.024,6.024,0,0,1-6.017-6.017V8.6A6.024,6.024,0,0,1,8.6,2.579H18.912A6.024,6.024,0,0,1,24.929,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M134.877,128a6.877,6.877,0,1,0,6.877,6.877A6.877,6.877,0,0,0,134.877,128Zm0,11.175a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,134.877,139.175Z",
    transform: "translate(-121.123 -121.123)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.916,
    cy: 0.916,
    r: 0.916,
    transform: "translate(20.231 5.445)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsta);
export default __webpack_public_path__ + "static/media/icon_insta.e18ff708e27bc769d17e7125051a1f6d.svg";
export { ForwardRef as ReactComponent };